import React from "react";
import Info from "./components/info";
import Main from "./components/main/main";

function Footer() {
  return (
    <div className="footer">
      <Main />
      <Info />
    </div>
  );
}

export default Footer;
